<template>
  <b-row :no-gutters="true" class="myRow" style="border: solid black 1px">
    <b-col md="1">
      &nbsp;{{ route.routeNo }}
      <span :v-show="route.startLoc != null" class="text-uppercase" :title="locDetails(route.startLoc)"
        @click="showLocDetails(route.startLoc)">
        {{ route.startLoc }}
      </span>
    </b-col>
    <b-col md="2">
      <span :v-show="route.activity">
        {{ route.activity }}
      </span>
    </b-col>
    <b-col md="2">
      <div :v-show="route.note">
        {{ route.note }}
      </div>
      <div :v-show="route.edi204ShipmentId">
        {{ route.edi204ShipmentId }}
      </div>
    </b-col>
    <b-col md="1">
      <span :v-show="route.truck">
        {{ route.truck }}
      </span>
    </b-col>
    <b-col md="2" style="white-space: nowrap">
      <span :v-show="trailerScacId">{{ trailerScacId }} </span>
      <button v-show="trailer" :disabled="trailer == null || started || readOnly" @click="showUpdateTrailerStatus">
        <TrailerLoadedDisplay :pr="8" :pl="8" :loadedOverride="statusOverride" :trailer="trailer" />
      </button>
      <span v-show="trailer && route.trailerStatus == null" style="font-weight: bold">*</span>
    </b-col>
    <b-col md="1">
      <span :v-show="route.endLoc" class="text-uppercase" :title="locDetails(route.endLoc)"
        @click="showLocDetails(route.endLoc)">{{ route.endLoc }}</span>
    </b-col>
    <b-col md="3">
      <b-row>
        <b-col md="6" style="font-size: smaller">
          {{ displayWait }}
          <span v-if="displayWait != null && route.startTime == null" style="font-weight: bold">*</span>
          <span v-if="displayStartTime != null">/ {{ displayStartTime }}</span>
          <span v-if="displayEndTime != null">/ {{ displayEndTime }}</span>
          <span v-if="displayDuration != null">/ {{ displayDuration }}</span>
        </b-col>
        <b-col md="6">
          <b-row :no-gutters="true">
            <b-col class="col" :class="waitingRunningClass" style="padding: 0px">
              <span v-show="canStart && !readOnly">Waiting to Start</span>
              <span v-show="started && !ended && !readOnly">Running Route</span>
              &nbsp;
            </b-col>
            <b-col class="col-auto" style="padding: 0px">
              <button title="Start Route" class="btn" v-show="canStart && !readOnly" @click="startRoute(route)">
                <font-awesome-icon icon="play-circle" />
              </button>
              <button title="End Route" class="btn" v-show="started && !ended" @click="endRoute(route)">
                <font-awesome-icon icon="stop-circle" />
              </button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import textutils from "../../textutils";
import dateutil from "../../dateutil";
import moment from "moment";
import TrailerLoadedDisplay from "../trailer/TrailerLoadedDisplay.vue";
import { edi } from "../../api/integrationapi";

//{type: 'route', id: route.id, title: `${route.driverWorkDay.driver.firstName} ${route.driverWorkDay.driver.lastName}'s Route`}
export default {
  components: {
    TrailerLoadedDisplay,
  },
  props: {
    route: Object,
    driver: Object,
  },
  data() {
    return {
      trailerScacId:
        this.route.trailer != null
          ? `${this.route.trailer.scac} ${this.route.trailer.id}`
          : null,
      dataChanged: false,
      startTimeForWait: null,
      displayWait: null,
      displayDuration: null,
      timerHandle: null,
      trailerScacIdChanged: false,
      attachmentCount: 0,
    };
  },
  computed: {
    ...mapGetters("common", ["errorMessage"]),
    ...mapGetters("routes", ["routesForDriver", "readOnly", "destinations"]),
    uploadTitle() {
      return `Documents for ${this.route.driverWorkDay.driver.firstName} ${this.route.driverWorkDay.driver.lastName}'s Route ${this.route.routeNo}`;
    },
    trailer() {
      return this.route.trailer != null ? this.route.trailer : null;
    },
    started() {
      return this.route.startTime != null;
    },
    ended() {
      return this.route.endTime != null;
    },
    routes() {
      return this.routesForDriver(this.route.driverWorkDay.driver);
    },
    hasAttachments() {
      return this.attachmentCount > 0;
    },
    prevRoute() {
      let prev = null;
      if (this.routes != null) {
        prev = this.routes.find((r) => r.routeNo == this.route.routeNo - 1);
      }
      return prev;
    },
    statusOverride() {
      let s = null;
      if (this.route.trailerStatus != null) {
        s = this.route.trailerStatus;
      }
      return s;
    },
    canStart() {
      let prevEnd =
        this.prevRoute != null ? this.prevRoute.endTime != null : true;
      let validRoute =
        this.route.startLoc != null &&
        this.route.activity != null &&
        this.route.endLoc != null;
      let started = this.route.startTime != null;
      let saved = !this.dataChanged;
      return (
        prevEnd && validRoute && !started && saved && !this.trailerScacIdChanged
      );
    },
    waitingRunningClass() {
      let c = null;
      if (this.started && !this.ended) {
        c = "routeStartedLabel";
      }
      if (this.canStart && !this.readOnly) {
        c = "routeCanStartLabel";
      }
      return c;
    },
    canSave() {
      return (
        !this.started &&
        !this.trailerScacIdChanged &&
        this.dataChanged &&
        !this.readOnly
      );
    },
    displayStartTime() {
      return this.route.startTime != null
        ? dateutil.getLocalDateTime(this.route.startTime, "h:mm a")
        : null;
    },
    displayEndTime() {
      let r = null;
      if (this.route.startTime != null) {
        if (this.route.endTime != null) {
          r = dateutil.getLocalDateTime(this.route.endTime, "h:mm a");
        } else {
          r = "--:--";
        }
      }
      return r;
    },
    trailerScacIdValid() {
      let v = textutils.toUpper(this.trailerScacId);
      let r = true;
      if (v != null) {
        let parts = v.split(" ");
        if (parts.length != 2) {
          r = false;
        }
      }
      return r;
    },
  },
  watch: {
    route(newVal) {
      if (newVal != null) {
        this.dataChanged = false;
      }
    },
    trailer(newVal) {
      if (newVal != null) {
        this.trailerScacId = `${this.route.trailer.scac} ${this.route.trailer.id}`;
      } else {
        this.trailerScacId = null;
      }
    },
    routes() {
      this.calcStartTimeForWait();
    },
  },
  methods: {
    ...mapActions("common", ["setErrorMessage"]),
    ...mapActions("routes", [
      "deleteRoute",
      "updateRouteStartLoc",
      "updateRouteActivity",
      "updateRouteEndLoc",
      "updateRouteNote",
      "updateRouteTrailer",
      "updateRoute",
      "updateRouteEdi",
      "startRoute",
      "endRoute",
      "findTrailer",
      "setSelectedDriverRoute",
    ]),
    showLocDetails(loc) {
      let d = this.locDetails(loc);
      alert(d);
    },
    assignTenderToRouteClicked() {
      this.setSelectedDriverRoute(this.route);
      this.$bvModal.show("addLadingRouteModal");
    },
    remoteTenderFromRouteClicked() {
      let str = JSON.stringify(this.route);
      let copy = JSON.parse(str);
      copy.edi204Id = null;
      copy.edi204ShipmentId = null;
      this.updateRouteEdi(copy);
    },
    shipmentIdClicked(id) {
      window.open(edi.generateEdi204SheetLink(id), "_new");
    },
    printShipmentClicked(id) {
      window.open(`${edi.generateEdi204PdfSheetLink(id)}?inline=true`, "_new");
    },
    locDetails(loc) {
      let d = null;
      if (loc) {
        let y = this.destinations.find((x) => x.code == loc);
        if (y) {
          d = `${y.name}\n${y.address}\n${y.city}, ${y.state} ${y.zip}`;
        }
      }
      return d;
    },
    attachmentsUpdated(x) {
      this.attachmentCount = x;
    },
    showUpdateTrailerStatus() {
      let obj = {
        title: `Update status for ${this.trailer.scac} ${this.trailer.id}`,
        trailer: this.trailer,
      };
      this.$modal.show("updateTrailerStatusModal", obj);
    },
    setDataChanged() {
      this.dataChanged = true;
    },
    startLocBlur() {
      this.dataChanged = true;
      this.route.startLoc = textutils.toUpper(this.route.startLoc);
      if (this.started) {
        this.updateRouteStartLoc(this.route);
      }
    },
    endLocBlur() {
      this.dataChanged = true;
      this.route.endLoc = textutils.toUpper(this.route.endLoc);
      if (this.started) {
        this.updateRouteEndLoc(this.route);
      }
    },
    billableBlur() {
      this.dataChanged = true;
    },
    noteBlur() {
      this.route.note = textutils.toUpper(this.route.note);
      if (this.started) {
        this.updateRouteNote(this.route);
      }
    },
    activityChanged() {
      this.dataChanged = true;
      if (this.started) {
        this.updateRouteActivity(this.route);
      }
      if (this.route.activity != null) {
        switch (this.route.activity) {
          case "FUELING":
          case "ON BREAK":
          case "ON LUNCH":
            this.route.endLoc = this.route.startLoc;
            break;
        }
      }
    },
    clearTrailer() {
      this.trailerScacId = null;
      this.trailerScacIdBlur();
    },
    setTrailerScacIdChanged() {
      this.trailerScacIdChanged = true;
    },
    setTrailerScacId(res) {
      this.trailerScacId = `${res.data.payload.scac} ${res.data.payload.id}`;
      this.trailerScacIdBlur();
    },
    async trailerScacIdBlur() {
      this.trailerScacIdChanged = false;
      if (this.errorMessage != null) {
        this.setErrorMessage(null);
      }
      if (this.trailerScacIdValid) {
        if (
          this.trailerScacId != null &&
          this.trailerScacId.trim().length > 0
        ) {
          let v = textutils.toUpper(this.trailerScacId);
          let parts = v.split(" ");
          let t = { scac: parts[0].trim(), id: parts[1].trim() };
          let res = await this.findTrailer(t);
          if (res) {
            this.route.trailer = res.data.payload;
            this.dataChanged = true;
          } else {
            let obj = {
              scac: t.scac,
              id: t.id,
              title: "Add Unknown Trailer",
              status: "EMPTY",
              callback: this.setTrailerScacId,
            };
            this.trailerScacId = null;
            this.$modal.show("addTrailerModal", obj);
          }
        } else {
          this.route.trailer = null;
          this.dataChanged = true;
        }
      } else {
        this.trailerScacId = null;
        this.route.trailer = null;
        this.setErrorMessage(
          "Trailer must have be in the format of: SCAC TRAILERNO",
        );
      }
      if (this.started) {
        this.updateRouteTrailer(this.route);
      }
    },
    calcStartTimeForWait() {
      this.displayDuration;
      if (this.route.startTime != null) {
        this.startTimeForWait = moment(this.route.startTime);
      } else {
        this.startTimeForWait = moment();
      }
      let w = null;
      if (this.prevRoute != null) {
        if (this.prevRoute.endTime != null) {
          let s = moment(this.prevRoute.endTime);
          let e = this.startTimeForWait;
          w = moment.duration(e.diff(s)).format("h:mm");
        }
      } else {
        w = moment.duration(0).format("h:mm");
      }
      this.displayWait = w;
    },
    calcDuration() {
      let d = null;
      if (this.route.startTime != null) {
        let s = moment(this.route.startTime);
        let e =
          this.route.endTime != null ? moment(this.route.endTime) : moment();
        d = moment.duration(e.diff(s)).format("h:mm");
      }
      this.displayDuration = d;
    },
    onTick() {
      this.calcStartTimeForWait();
      this.calcDuration();
    },
  },
  mounted() {
    this.onTick();
    this.timerHandle = window.setInterval(this.onTick, 1000 * 60);
  },
  beforeDestroy() {
    window.clearInterval(this.timerHandle);
  },
};
</script>

<style scoped>
.btn {
  background-color: lightgrey;
}

.btn:hover {
  background-color: lightgreen;
}

.myRow:hover {
  background-color: antiquewhite;
}

.routeCanStartLabel {
  background-color: yellow;
}

.routeStartedLabel {
  background-color: green;
  color: white;
}
</style>
